import React, { useState } from 'react';
import { styles } from './styles/globalStyles';
import { Header } from './components/Layout';
import { HeroSection } from './components/Hero';
import { AgentBuilderSection } from './components/AgentBuilder';
import { DashboardSection } from './components/Dashboard';
import { AgentLibrarySection } from './components/AgentLibrary';
import { AgentDetailModal } from './components/Modal';
import { PlatformSection, KeyFeaturesSection, UseCasesSection, FinalCTASection } from './components/common';

const AgentPlatform = () => {
  const [selectedAgent, setSelectedAgent] = useState(null);

  const handleSelectAgent = (agent) => {
    setSelectedAgent(agent);
  };

  const handleCloseModal = () => {
    setSelectedAgent(null);
  };




  return (
    <div style={styles.container}>
      <Header />
      <HeroSection />
      <PlatformSection />
      <DashboardSection />
      <AgentLibrarySection onSelectAgent={handleSelectAgent} />
      <AgentDetailModal selectedAgent={selectedAgent} onClose={handleCloseModal} />
      <KeyFeaturesSection />
      <UseCasesSection />
      <AgentBuilderSection />
      <FinalCTASection />
    </div>
  );
};

export default AgentPlatform;